export const MAX_COLOR = 5;
export const TEXT_MORE = 'more';
